module.exports = __webpack_public_path__ + "img/schedule.468718cf.svg";